import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
type FaqItem = {
  question: string;
  answer: string;
};
const FAQS: FaqItem[] = [{
  question: '¿Necesito saber de tecnología para entender este contenido?',
  answer: 'No. Esta guía fue creada exactamente para personas que no tienen conocimientos técnicos. Todo está explicado con lenguaje simple, pasos claros y ejemplos del día a día.'
}, {
  question: '¿Sirve para cualquier modelo de iPhone?',
  answer: 'Sí. El contenido aplica para la gran mayoría de modelos de iPhone con iOS actual. Ya tengas un iPhone más reciente o uno de hace algunos años, vas a encontrar información útil y aplicable.'
}, {
  question: '¿También sirve si vengo de Android?',
  answer: 'Sí, especialmente para ti. Si cambiaste de Android y todavía no entiendes bien cómo funciona iOS, esta guía te va a ayudar a entender la lógica del iPhone desde el principio.'
}, {
  question: '¿El contenido es difícil de aplicar?',
  answer: 'No. Cada sección está diseñada para que puedas aplicar lo que aprendes de forma inmediata. No necesitas ser experto, no necesitas herramientas externas y no necesitas mucho tiempo.'
}, {
  question: '¿Recibo acceso inmediato después de comprar?',
  answer: 'Sí. Una vez que completas tu compra, recibes acceso inmediato al contenido para que puedas empezar hoy mismo.'
}, {
  question: '¿Puedo verlo desde mi iPhone?',
  answer: 'Sí. Puedes acceder al contenido desde tu iPhone, iPad, computadora o cualquier dispositivo con acceso a internet.'
}, {
  question: '¿Incluye trucos de cámara, seguridad y organización?',
  answer: 'Sí. El libro principal cubre todo eso, y además recibes 5 bonos adicionales que profundizan en configuración, seguridad, organización, trucos ocultos y cámara.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Tienes la garantía de satisfacción disponible en la plataforma. Si el contenido no cumple tus expectativas, puedes solicitar tu devolución dentro del período indicado.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-ink-950" data-id="element-98" data-mp="2fwalg7ohw8vl">
      <SectionTitle eyebrow="Preguntas frecuentes" data-id="element-99" data-mp="2fxlm3ymn90ih">
        Preguntas que quizás tienes en este momento
      </SectionTitle>

      <div className="space-y-3" data-id="element-100" data-mp="2avo04wmuzrlu">
        {FAQS.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.question} className="overflow-hidden rounded-2xl border border-white/8 bg-ink-900" data-id="element-101" data-mp="33mely66dzsid" data-mpi={index}>
              <h3 data-id="element-102" data-mp="2ymsb23e16ocq">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-sm font-semibold text-white transition-colors hover:bg-white/[0.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent sm:px-7 sm:text-base" data-id="element-103" data-mp="2yma70kl4n5u9">
                  {faq.question}
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.2
              }} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/5" data-id="element-104" data-mp="3uupnmrkw3og3">
                    <PlusIcon className="h-4 w-4 text-accent-soft" aria-hidden="true" data-id="element-105" data-mp="7nvwc12ca6zq" />
                  </motion.span>
                </button>
              </h3>

              <AnimatePresence initial={false} data-id="element-106" data-mp="hdyqw5p3zt06">
                {isOpen ? <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.28,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-107" data-mp="me39c19kuxt1">
                    <p className="px-5 pb-6 text-sm leading-relaxed text-white/60 sm:px-7 sm:text-base" data-id="element-108" data-mp="2s8menhbz82nn">
                      {faq.answer}
                    </p>
                  </motion.div> : null}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}